import * as React from 'react';
import logo from './logo.svg';
import logoSlogan from './nest-logo-with-slogan.png';
// import PropTypes from 'prop-types';

export const Logo = (props) => {
	return <img {...props} src={props.slogan ? logoSlogan : logo} className={`${props.className || ''}`} />;
};
// Logo.propTypes = {
// 	slogan: PropTypes.bool
// };
export default Logo;
